import { TravelCardsDto, UpdateTravelCardDto, TravelCardOrderDetailsDto, TravelCardDto } from '../../types';
import TravelCardApi from '../';
import { AxiosResponse } from 'axios';

const travelCardApi = new TravelCardApi();
export const getTravelCards = async (take?: number): Promise<TravelCardsDto | undefined> => {
    return await travelCardApi.getTravelCards(take);
};

export const createTravelCard = async (name: string, number: string): Promise<AxiosResponse<TravelCardDto>> => {
    return await travelCardApi.createTravelCard(name, number);
};

export const blockTravelCard = async (id: string): Promise<void> => {
    return await travelCardApi.blockTravelCard(id);
};

export const updateTravelCard = async (id: string, name: string): Promise<UpdateTravelCardDto | undefined> => {
    return await travelCardApi.updateTravelCard(id, name);
};

export const deleteTravelCard = async (id: string): Promise<void> => {
    return await travelCardApi.deleteTravelCard(id);
};

export const getTravelCardOrders = async (cardNumbers: string, language: string): Promise<TravelCardOrderDetailsDto[] | undefined> => {
    return await travelCardApi.getMultipleTravelCardData(cardNumbers, language);
};

export const validateTravelCardNumber = async (cardNumber: string): Promise<boolean> => {
    return await travelCardApi.validateTravelCardNumber(cardNumber);
};
